(() => {
  'use strict';

  class WURangeSelector extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.buttons = Array.from(this.querySelectorAll('[data-wu-range-option]'));
      this.rangeValue = this.querySelector('[data-wu-range-value]');
      this.speedValue = this.querySelector('[data-wu-speed-value]');
      this.fill = this.querySelector('[data-wu-range-fill]');
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.select(button));
      });
    }

    select(button) {
      this.buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (this.rangeValue) this.rangeValue.textContent = button.dataset.range;
      if (this.speedValue) this.speedValue.textContent = button.dataset.speed;
      if (this.fill) this.fill.style.width = `${button.dataset.percent}%`;
    }
  }

  if (!customElements.get('wu-range-selector')) {
    customElements.define('wu-range-selector', WURangeSelector);
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let videoObserver;

  const bindVideos = (root = document) => {
    const videos = root.querySelectorAll('[data-wu-autoplay] video:not([data-wu-bound])');
    if (!videos.length) return;

    if (!videoObserver && 'IntersectionObserver' in window) {
      videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && !reducedMotion.matches) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { rootMargin: '120px 0px', threshold: 0.2 });
    }

    videos.forEach((video) => {
      video.dataset.wuBound = 'true';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      if (videoObserver) videoObserver.observe(video);
    });
  };

  const initialize = (root = document) => bindVideos(root);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
